// extracted by mini-css-extract-plugin
export default {"warningIcon":"WarningIcon_warningIcon__bCI1h","placeholder":"WarningIcon_placeholder__zpoof"};